/*
|--------------------------------------------------------------------------
| Schedule query options
|--------------------------------------------------------------------------
|
| The schedule loads a range's whole set of shifts, time off and
| availability, and one list of people, and reads each from many places.
| Switching between the area and employee views remounts those readers, and
| a query with the app's default stale time of zero refetches whenever a new
| reader mounts. Keeping the results fresh for a while means a remount reads
| the cache; the toolbar's refresh button and every mutation still
| invalidate, so edits made here show at once.
*/

/** How long a schedule query's result is read from the cache before it is fetched again on mount */
export const SCHEDULE_STALE_TIME = 5 * 60 * 1000
